import { SmartLink } from '@undataforum/components';

// Shadow default styled.a mapping for anchors.
const components = {
  a: SmartLink,
};

export default components;
